import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';

export const opdReportColumns = [
 
  {
    field: "patientName",
    headerName: "Patient Name",
    width: 200,
  },
  {
    field: "age",
    headerName: "Age",
    width: 50,
  },
  {
    field: "gender",
    headerName: "Gender",
    width: 100,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          {
            params?.row?.gender === "0" ? <><WomanIcon style={{ color: "pink"}}/>Female </>: 
            params?.row?.gender === "1" ? <><ManIcon style={{ color: "blue"}} /> Male</> : "Others"
          }
          
        </div>
      );
    },
  },
  {
    field: "mobile",
    headerName: "Mobile",
    width: 150,
  },
  {
    field: "city",
    headerName: "City",
    width: 150,
  },


  {
    field: "address",
    headerName: "Address ",
    width: 250,
  },

  {
    field: "doctorName",
    headerName: "Doctor Name",
    width: 200,
  },

  {
    field: "patientRegistrationDate",
    headerName: "Patient Registration Date",
    width: 200,
  },
  {
    field: "referralName",
    headerName: "Referral Name",
    width: 200,
  },
  {
    field: "referralCode",
    headerName: "Referral Code",
    width: 150,
  },
  {
    field: "departmentName",
    headerName: "Department Name",
    width: 200,
  },
  {
    field: "departmentCode",
    headerName: "Department Code",
    width: 150,
  },
  
];
